export default "__VITE_ASSET__CcB63OTr__"